module.exports = __webpack_public_path__ + "js/components/Desktop/images/twitterIcon-acc1b51d814e552d1458be2e76f0c91f.png";